import { TypedDocumentNode } from '@graphql-typed-document-node/core'

import { graphqlRequest } from './graphqlRequest'
import { useMutation, UseMutationOptions } from './useMutation'

export const useGqlMutation = <
  TResult,
  TVariables extends Record<string, unknown>,
>(
  document: TypedDocumentNode<TResult, TVariables>,
  options?: UseMutationOptions<TResult>,
) => {
  return useMutation(
    (variables: TVariables) => graphqlRequest(document, variables),
    options,
  )
}
